module.exports = __webpack_public_path__ + "img/4-23.dfb9b286.jpg";